import {
  Link,
  Paragraph,
  Stack,
  Title,
  useWizardPage
} from '@efast_public/fjd-component-library';
import { Trans, useTranslation } from 'react-i18next';
import React from 'react';
import { FJD_DOCS_SETTINGS_FITCONNECT } from '../../../shared/utils/Links';

export default function StartInfo() {
  const { t } = useTranslation();
  useWizardPage({
    isFormValid: true,
    headline: (state) =>
      `Schritt ${state.currentPageIndex + 1} von ${state.pagesLength}`
  });

  return (
    <Stack size="m">
      <Title level={2} visualLevel={6}>
        {t('settings.destinationSync.startPage.title')}
      </Title>
      <Paragraph>
        <Trans i18nKey="settings.destinationSync.startPage.desciption" />
        <Trans
          i18nKey="configAssistent.configAssistentDocumentationNotice"
          components={{
            Link: (
              <Link href={FJD_DOCS_SETTINGS_FITCONNECT} target="_blank">
                hier
              </Link>
            )
          }}
        />
      </Paragraph>
    </Stack>
  );
}
